module.exports = __webpack_public_path__ + "img/mandy-joy-deep-rover.a4ff89ea.jpg";